import { useProfileImage } from "./useProfileImagen";

export const useSidebarProfileImage = (userData) => {
  const { profileSrc } = useProfileImage(userData);

  return { srcCandidate: profileSrc };
};
